export default __webpack_public_path__ + "static/media/design_feed.4312da08.png";